import errorManager from '@/rollbar.js';

const stopRegistration = (subActivityCheckboxesArray, actionElement, event) => {
  if (subActivityCheckboxesArray.length && subActivityCheckboxesArray.every((cb) => !cb.checked)) {
    alert('Selezionare almeno una sottoattività!');
    if (event.cancelable) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (actionElement.type === 'checkbox') {
      actionElement.checked = false;
    }
    return false;
  }
  return true;
};

const stopRegistrationFromModal = (event, executeMultiactivityNoSubactivity, form) => {
  if (executeMultiactivityNoSubactivity) return true; // business unit parameter does not require the check

  const formDataset = form.dataset;
  const isRegistration = $(form).find('.js-close-activity').is(':checked');
  const motivationSelect = $(form).find('select[name="guest_activity_domestic[motivation]"]');
  const motivationNotDone = motivationSelect.find('option:selected').attr('data-done') === '0';

  if (formDataset['method'] === 'delete') return true; // during a deletion there is no point in checking this validation
  if (formDataset['fromAgenda'] === 'true' && !isRegistration) return true; // skip the validation if it is planning
  if (motivationNotDone) return true; // skip the validation if it is selected a not-done motivation

  const actionElement = $(event.currentTarget);
  const subActivityCheckboxes = document.querySelectorAll('.js-checkbox-sub-activities[type="checkbox"]');
  return stopRegistration(Array.from(subActivityCheckboxes), actionElement, event);
};

const showAlert = (subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity) => {
  if (executeMultiactivityNoSubactivity) return;

  const handleActivityRegistration = (event) => {
    const counter = event.currentTarget.dataset.id;
    const subActivityCheckboxes = document.querySelectorAll(`${subActivityCheckboxesSelector}.checkbox-${counter}`);
    const subActivityCheckboxesArray = Array.from(subActivityCheckboxes);
    stopRegistration(subActivityCheckboxesArray, event.currentTarget, event);
  };

  document.querySelectorAll(executeCheckboxSelector).forEach((executeCheckbox) => {
    executeCheckbox.removeEventListener('change', handleActivityRegistration);
    executeCheckbox.addEventListener('change', handleActivityRegistration);
  });

  document.querySelectorAll(stopButtonSelector).forEach((stopButton) => {
    stopButton.removeEventListener('click', handleActivityRegistration);
    stopButton.addEventListener('click', handleActivityRegistration);
  });
};

const init = (subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity) => {
  try {
    showAlert(subActivityCheckboxesSelector, stopButtonSelector, executeCheckboxSelector, executeMultiactivityNoSubactivity);
  } catch (e) {
    errorManager(e);
  }
};

window.MultiactivityRegistration = { init, stopRegistrationFromModal };
